import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  getResetPasswordToken,
  ResetPasswordTokenSchema,
  ResetPasswordTokenSchemaType,
} from "@/services/getResetPasswordToken";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";

const ResetPasswordToken = () => {
  const navigate = useNavigate();

  const resetPasswordTokenForm = useForm<ResetPasswordTokenSchemaType>({
    resolver: zodResolver(ResetPasswordTokenSchema),
    defaultValues: {
      email: "",
    },
  });

  const { mutate, isPending, isError, error } = useMutation({
    mutationFn: (email: ResetPasswordTokenSchemaType) =>
      getResetPasswordToken(email),
    onSuccess: () => {
      toast.success("Password reset code email sent. Please check your inbox");
      navigate(`/reset-password/${resetPasswordTokenForm.getValues("email")}`);
    },
    onError: (error) => {
      console.log("Reset password token error:", error);
      toast.error(
        "Failed to send reset password token email. Please try again."
      );
    },
  });
  const handleSubmit = (values: ResetPasswordTokenSchemaType) => {
    mutate(values);
  };

  return (
    <div className="flex items-center flex-1">
      <div className="w-full  md:w-2/5 border p-6 rounded-md mx-auto md:mt-20">
      <Form {...resetPasswordTokenForm}>
        <form
          
          onSubmit={resetPasswordTokenForm.handleSubmit(handleSubmit)}
        >
          <div className="mb-4">
            <h1 className="mb-2 text-2xl font-bold">
              Get reset password token
            </h1>
          </div>
          <div className="grid grid-cols-1 gap-6">
            <FormField
              control={resetPasswordTokenForm.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Email</FormLabel>
                  <FormControl>
                    <Input placeholder="Enter your email" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          

          <div className="flex gap-3 justify-end w-full">
            <Button type="submit" className="" disabled={isPending}>
              {isPending ? "Sending..." : "Get Reset Password Token"}
            </Button>
          </div>
          </div>
        </form>
      </Form>
      </div>
    </div>
  );
};

export default ResetPasswordToken;
